import React from 'react';
import InvoiceProductInfo from './InvoiceProductInfo';
import WarrantyCardDetail from './WarrantyCardDetail';
import { TWarrantyCard } from './interface';
import atoms from '../../atoms';

const { Button} = atoms

const Index:React.FC<TWarrantyCard> = ({ product, handleWarrantyClaim }) => {
  return (
    <div className='checkout-card'>
      <div className="d-flex flex-wrap justify-content-between">
        <InvoiceProductInfo
          invoiceNumber={product?.order?.invoice_number}
          productIdDisplay={product?.product?.product_id_display}
        />

        <div className='d-none d-md-flex mb-md-0 mb-3 justify-content-end'>
          <Button className='px-5' onClick={() => handleWarrantyClaim(product?.id)}>Claim</Button>
        </div>
      </div>

      <WarrantyCardDetail
        product={product}
        handleWarrantyClaim={(id:string)=>handleWarrantyClaim(id)}
      />
    </div>
  );
};

export default Index;
